import React, { FC } from 'react';
import { TagsInput } from 'react-tag-input-component';

interface TextTagsProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  label?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  labelClassName?: string;
}

const TextTags: FC<TextTagsProps> = ({
  tags,
  onChange,
  className,
  placeholder,
  disabled,
  label,
  labelClassName,
}) => {
  const onBlur = (event: any) => {
    if (event.target.value.trim()) {
      const newTag = event.target.value.trim();
      if (!tags.includes(newTag)) {
        onChange([...tags, newTag]);
      }
      event.target.value = '';
    }
  };
  return (
    <div className={className || 'form-group'}>
      <label className={labelClassName + ' mb-5'}>{label}</label>
      <TagsInput
        value={tags}
        onChange={onChange}
        name="tags"
        placeHolder={placeholder}
        disabled={disabled}
        onBlur={onBlur}
      />
    </div>
  );
};

export default TextTags;
